import { Link } from "react-router-dom";
import Rating from "../../Rating/Rating";
import { MdOutlinePlayLesson } from "react-icons/md";
import { IoPeopleOutline } from "react-icons/io5";
import { formatAmount } from "../../../utils/formatAmount";

const Card3 = ({
  bookImage,
  bookCaterory,
  bookTitle,
  ratings,
  bookPrice,
  to,
  toCategory,
  lessonNumber,
  bookStudent,
}) => {
  return (
    <div className="rounded-lg overflow-hidden shadow ">
      <Link to={to}>
        <img src={bookImage} alt="" className="" />
      </Link>
      <div className="p-2 space-y-3">
        <div className=" flex gap-4">
          <p className="text-[#004C97]">&#8358; {formatAmount(bookPrice)}</p> |
          <Link to={toCategory} className="hover:text-[#004C97]">
            <p>{bookCaterory}</p>
          </Link>
        </div>

        <Link to={to}>
          <h2 className="text-2xl hover:text-[#004C97] font-bold sm:text-lg">
            {bookTitle}
          </h2>
        </Link>

        <div>
          <Rating ratings={ratings} />
        </div>
        <div className="flex gap-5 pt-5 border-t">
          <div className="flex gap-2">
            <MdOutlinePlayLesson className="mt-1" />
            <p className="text-sm">{lessonNumber} Lesson</p>
          </div>
          <div className="flex gap-2">
            <IoPeopleOutline className="mt-1" />
            <p className="text-sm">{bookStudent} Students</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Card3;
